// extracted by mini-css-extract-plugin
export default {"col-status":"TableRecord_col-status__NoPF1","col-date":"TableRecord_col-date__hk9Jh"};